import { createSelector } from 'reselect';
import ReactDOMServer from 'react-dom/server';
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import {
  MonteCarloSplineChart,
  MonteCarloPercentagePieChart,
} from '../../js/app/react/chartDescriptors.financialPlan';
import MonteCarloChartTooltipView from './MonteCarloChartTooltipView';

export const buildProbabilityData = (pos, inversePos) => [
  {
    name: 'Unsuccessful',
    y: inversePos,
    color: '#8f959f',
  },
  {
    name: 'Successful',
    y: pos,
    color: pos < 70 ? '#ef4268' : '#0e9f6e',
  },
];

export const renderPieChartLabels = pieChartData => {
  function renderPieChartLabelsWithContext() {
    if (!this.Bookkeeping) {
      this.Bookkeeping = {
        svg: null,
      };
    }
    const { svg } = this.Bookkeeping;

    if (svg) {
      svg.element.remove();
    }

    this.Bookkeeping.svg = this.renderer
      .text(`${pieChartData.pos}%`, 35, 42)
      .css({
        fontSize: '16px',
        textAnchor: 'middle',
      })
      .attr({
        textAlign: 'center',
        zIndex: '10',
      })
      .add();
  }
  return renderPieChartLabelsWithContext;
};

export const responseDataSelector = (state, props) => {
  if (props.responseData) {
    return props.responseData;
  }
  return (state.MonteCarloChart[props.clientId] || {}).responseData || null;
};

export const chartsData = createSelector(
  responseDataSelector,
  (state, props) => props.isPdf,
  (responseData, isPrint) => {
    if (responseData == null || Object.keys(responseData).length < 1) {
      return {
        chartData: null,
        pieChartData: null,
      };
    }

    const chartData = cloneDeep(MonteCarloSplineChart);
    const pos = Math.round(responseData.ProbabilityOfSuccess * 100);
    const inversePos = 100 - pos;

    chartData.series = responseData.Data;
    chartData.xAxis.categories = responseData.Categories;

    if (responseData.IsEmpty) {
      chartData.yAxis.max = 10000;
    }

    function formatter() {
      return ReactDOMServer.renderToStaticMarkup(
        <MonteCarloChartTooltipView
          MonteCarloTrialsCount={responseData.MonteCarloTrialsCount}
          pos={pos}
          posColor={responseData.SuccessfulColor}
          inversePos={inversePos}
          inversePosColor={responseData.UnsuccessfulColor}
        />,
      );
    }

    chartData.tooltip.formatter = formatter;

    const pieChartData = cloneDeep(MonteCarloPercentagePieChart);
    const pieChartDataPos = {
      inversePos,
      pos,
    };

    pieChartData.series[0].data = buildProbabilityData(pos, inversePos);
    pieChartData.chart.events = {
      load: renderPieChartLabels(pieChartDataPos),
      redraw: renderPieChartLabels(pieChartDataPos),
    };

    if (isPrint) {
      chartData.series.forEach(serieArg => {
        const serie = serieArg;
        serie.animation = false;
      });
      pieChartData.series.forEach(serieArg => {
        const serie = serieArg;
        serie.animation = false;
      });
    }

    return {
      chartData,
      pieChartData,
    };
  },
);

export const loadingSelector = (state, { clientId }) => {
  const { loading } = state.MonteCarloChart[clientId] || {};
  return (loading || 0) !== 0;
};

export const requestedWithSelector = createSelector(
  (state, props) => state.MonteCarloChart[props.clientId] || {},
  clientMc =>
    clientMc.requestedWith || {
      clientId: null,
      IsPdf: null,
      fpId: null,
      stagedWhatIfs: [],
    },
);

export const stagedWhatIfsSelector = createSelector(
  (state, props) => state.MonteCarloChart[props.clientId] || {},
  clientMc => clientMc.stagedWhatIfs || [],
);
